import { withConfigTransport } from '../../services/config-transport'
import _VaLayout from './VaLayout.vue'

export const VaLayout = withConfigTransport(_VaLayout)
